// Pure helpers for the pack screen's item list (dispatch-order-pack.tsx).

/** How long a line that has just been finished stays in place, flashing
 *  green, before it drops to the finished group at the bottom. Moving it
 *  the instant it resolved sent it below the fold on the short Polish bench
 *  screens, so the packer heard the beep but never saw the confirmation. */
export const RESOLVED_HOLD_MS = 1000;

/** Display order: lines still to do first, finished lines last — except
 *  lines finished a moment ago (`held`), which keep their place while they
 *  flash. Array.prototype.sort is stable, so each group keeps order order. */
export const sortForPacking = <T extends { item_id: string }>(
    items: readonly T[],
    isResolved: (item: T) => boolean,
    held: ReadonlySet<string>,
): T[] => {
    const rank = (item: T) => (isResolved(item) && !held.has(item.item_id) ? 1 : 0);
    return [...items].sort((a, b) => rank(a) - rank(b));
};

/** How many lines are wholly or partly below the visible bottom of the
 *  list, given each line's bottom edge and the list's visible bottom (both
 *  in the list's scroll coordinates). `tolerance` absorbs sub-pixel
 *  rounding so a line that fits exactly doesn't count. */
export const countRowsBelow = (rowBottoms: readonly number[], visibleBottom: number, tolerance = 2): number =>
    rowBottoms.filter(bottom => bottom > visibleBottom + tolerance).length;
